
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15706","data-name":"Rectangle 15706","width":"25","height":"25","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_46513","data-name":"Group 46513","transform":"translate(-804 -659)"}},[_c('g',{attrs:{"id":"Group_46500","data-name":"Group 46500","transform":"translate(804 659)"}},[_c('rect',{attrs:{"id":"Rectangle_15705","data-name":"Rectangle 15705","width":"25","height":"25","fill":"none"}}),_c('g',{attrs:{"id":"Group_46488","data-name":"Group 46488"}},[_c('g',{attrs:{"id":"Group_46487","data-name":"Group 46487","clip-path":"url(#clip-path)","fill":"none","stroke":"#8c96a1","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_38729","data-name":"Path 38729","d":"M2.536 12.788a.813.813 0 010-.571A10.464 10.464 0 0112.5 5.8a10.469 10.469 0 019.963 6.415.8.8 0 010 .571A10.462 10.462 0 0112.5 19.2a10.469 10.469 0 01-9.963-6.415z"}}),_c('circle',{attrs:{"id":"Ellipse_948","data-name":"Ellipse 948","cx":"3","cy":"3","r":"3","transform":"translate(9.613 9.5)"}})])])])])])
          )
        }
      }
    